import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import {
  COMMON_TRAITS,
  CONTRACT_NOTE,
  CRITERIA,
  INVEST_EXAMPLE,
  INVEST_NOTE,
  MASS_PRODUCTION,
  MESSAGES,
  PARTNERSHIP_FAQ,
  PARTNERSHIP_INTRO,
  POSITIONING,
  ROLES,
} from "../content";
import { ContractTable, CtaBand, FaqList, PageHero, PARTNER_LINK, SectionHead, SegmentCards, useSeo } from "../ui";

export default function Partnership() {
  useSeo({
    title: "제품개발 서비스 — 공동개발 Partnership, 개발비 일부는 I.META가 투자합니다 | I.META",
    description:
      "선별한 프로젝트에 한해 I.META가 개발비 일부를 기술투자로 부담하고, 양산 대행·로열티·지분으로 성과를 함께 가져갑니다. 일반 개발·Partnership·Venture 3가지 계약 방식과 심사 기준. 제품 개발 파트너, 시제품 제작, 양산.",
    path: "/partnership",
  });

  return (
    <>
      {/* 1. 도입 */}
      <PageHero kicker="제품개발 서비스 · PARTNERSHIP" title={MESSAGES.alt.partner} desc={PARTNERSHIP_INTRO[0]}>
        <p className="page-hero__quote">{PARTNERSHIP_INTRO[1]}</p>
        <div className="hero__actions">
          <Link to={PARTNER_LINK} className="btn btn--primary">
            개발 문의 하기 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
          <a href="#criteria" className="btn btn--ghost">심사 기준 보기</a>
        </div>
      </PageHero>

      {/* 2. 3가지 계약 방식 */}
      <section id="models" className="section section--tight">
        <SectionHead kicker="3 WAYS" title="3가지 계약 방식" desc={CONTRACT_NOTE} />
        <ContractTable />
        <p className="note-line">{POSITIONING.lines[1]}</p>
      </section>

      {/* 3. 기술투자 개념 설명 */}
      <section className="section">
        <div className="split">
          <SectionHead kicker="TECH INVESTMENT" title="기술투자" desc={INVEST_NOTE} />
          <div className="invest" aria-label="기술투자 예시">
            <div className="invest__cap">예시</div>
            {INVEST_EXAMPLE.map((r) => (
              <div key={r.label} className={`invest__row ${r.accent ? "invest__row--accent" : ""}`}>
                <span>{r.label}</span>
                <strong>{r.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. 양산까지 책임집니다 */}
      <section className="section">
        <SectionHead kicker="MASS PRODUCTION" title={MASS_PRODUCTION.title} desc={MASS_PRODUCTION.desc} />
      </section>

      {/* 5. 역할 분담 */}
      <section className="section section--flush">
        <SectionHead kicker="ROLES" title="역할 분담" desc={MESSAGES.support.field} />
        <div className="roles">
          {ROLES.map((r) => (
            <div key={r.who} className={`roles__col ${r.accent ? "roles__col--accent" : ""}`}>
              <h3 className="roles__who">{r.who}</h3>
              <ul className="roles__list">
                {r.items.map((it) => <li key={it}>{it}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* 6. 심사 기준 공개 */}
      <section id="criteria" className="section">
        <SectionHead kicker="CRITERIA" title="심사 기준 공개" />
        <ol className="criteria">
          {CRITERIA.map((c, i) => (
            <li key={c} className="criteria__item">
              <span className="criteria__no">{i + 1}</span>
              <span className="criteria__text">{c}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* 이런 분들과 만듭니다 (문서 §2) */}
      <section className="section">
        <SectionHead kicker="WHO WE WORK WITH" title="이런 분들과 만듭니다" />
        <ul className="checklist checklist--row traits">
          {COMMON_TRAITS.map((t) => (
            <li key={t}>
              <Icon.Check width="15" height="15" aria-hidden="true" focusable="false" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
        <SegmentCards showAll />
      </section>

      {/* 7. FAQ */}
      <section id="faq" className="section">
        <SectionHead kicker="FAQ" title="자주 묻는 질문" />
        <FaqList items={PARTNERSHIP_FAQ} />
      </section>

      <CtaBand title={MESSAGES.support.invest} desc={MESSAGES.alt.start} />
    </>
  );
}
